import { useEffect } from 'react';

export const useFetchTableData = (pagination, user, fetchTableData, setIsLoading) => {
  useEffect(() => {
    setIsLoading(true);
    fetchTableData(pagination?.pageSize, pagination?.current, user?.id);
  }, [user, fetchTableData, setIsLoading]);
};
